module.exports = __webpack_public_path__ + "static/media/activation-home-ios.339020d4.webp";